import { Box, ListItem, List, Typography } from '@mui/material';

function SMSSubscriptionHelpText({ status }) {
  return (
    <Box sx={{ p: 1 }}>
      <List disablePadding>
        <ListItem
          key={status.title}
          disableGutters
          alignItems="flex-start"
          sx={{ mb: 1 }}>
          <Box>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
              {status.title}
            </Typography>
            <Typography variant="body2">{status.detail}</Typography>
          </Box>
        </ListItem>
      </List>
    </Box>
  );
}

export default SMSSubscriptionHelpText;
